import {
  CreateResource,
  CustomQueryHookResult,
  DeleteResource,
  GetByIdResource,
  ListResource,
  PutResource,
  UnpagedListResource,
  createApiResource,
  useCustomQuery
} from '../apiResourceFactory';
import { API } from '../apiService';
import {
  CompanyWindowQueryParams,
  CompanyWindowListDTO,
  CompanyWindowDetailDTO,
  CompanyWindowUpdateDTO,
  CompanyWindowCreateDTO
} from '../apiTypes.shim';

interface CompanyWindowResource
  extends GetByIdResource<CompanyWindowDetailDTO>,
    UnpagedListResource<CompanyWindowListDTO, CompanyWindowQueryParams>,
    ListResource<CompanyWindowListDTO, CompanyWindowQueryParams>,
    PutResource<CompanyWindowUpdateDTO, CompanyWindowDetailDTO>,
    CreateResource<CompanyWindowCreateDTO, CompanyWindowDetailDTO>,
    DeleteResource {
  /**
   * Custom query that returns 'true' if the companyWindowId is associated with any appointment windows
   */
  useHasAppointmentWindows: (companyWindowId: string) => CustomQueryHookResult<boolean>;
}

export const createCompanyWindowResource = (): CompanyWindowResource => {
  const companyWindowResourceUri = `company-window`;

  const useHasAppointmentWindows = (companyWindowId: string) =>
    useCustomQuery({
      queryKey: [companyWindowResourceUri, companyWindowId, 'has-appointment-windows'],
      queryFn: async () => {
        const res = await API.get<{ exists: boolean }>(
          `${companyWindowResourceUri}/${companyWindowId}/has-appointment-windows`,
          { extraOptions: { retry: 1 } }
        );
        return res.data.exists;
      }
    });

  const {
    getById,
    useGetById,
    getByIdQueryKey,
    unpagedList,
    useUnpagedList,
    unpagedListQueryKey,
    list,
    useList,
    listQueryKey,
    put,
    usePut,
    create,
    useCreate,
    deleteItem,
    useDelete
  } = createApiResource(API, companyWindowResourceUri);
  return {
    getById,
    useGetById,
    getByIdQueryKey,
    unpagedList,
    useUnpagedList,
    unpagedListQueryKey,
    list,
    useList,
    listQueryKey,
    put,
    usePut,
    create,
    useCreate,
    deleteItem,
    useDelete,
    useHasAppointmentWindows
  };
};
